import React, { useContext, useRef, useState, useEffect } from 'react';
import classNames from '../../../src/components/AddUserForm/addUserForm.module.scss';
import message from 'antd/lib/message';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { useQuery } from 'react-query';
//import LoadingAnimation from '../LoadingAnimation';
import { ArrowRightOutlined } from '@ant-design/icons';
import Button from '../../NecttosComp/Button/Button';
import Input2 from '../../NecttosComp/Input/Input2';
import { Main } from '../../NecttosComp/Layout/Layout';
import { NecttosContext } from '../../context/NecttosContext';


const getClassesList = async ({ queryKey }) => {
    const [_, { collegeId }] = queryKey;
    const instance = await getAxiosTokenInstance();
    const resp = await instance.get('/college/classes/getClass', {
        params: { collegeId, needAll: true },
    });
    if (resp.data.statusCode !== 200) throw new Error(resp.data.message || 'API Error');
    return resp.data;
};

function AddNewUsertoAdmission({ onClose }) {
    const ref = useRef();
    const { collegeId, profile } = useContext(NecttosContext);
    const [isLoading, setIsLoading] = useState(false);
    const [formValues, setFormValues] = useState({
        fullName: '',
        phoneNumber: '',
        classId: '',
    });



    const classQuery = useQuery(['classes', { collegeId }], getClassesList);

    const handleChange = (key, value) => {
        setFormValues((prev) => ({ ...prev, [key]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setIsLoading(true);
            const instance = await getAxiosTokenInstance();
            const payload = {
                collegeId,
                fullName: formValues.fullName,
                phoneNumber: formValues.phoneNumber.replace('+91', ''),
                classId: formValues.classId,
                uid: profile._id,
            };

            const resp = await instance.post('/college/admissionProcess2/createStudentAccount', payload);
            if (resp.data.statusCode !== 200) throw new Error(resp.data.message || 'API Error');
            message.success(resp.data.message || 'Student Added');
            setFormValues({ fullName: '', phoneNumber: '', classId: '' });
        } catch (err) {
            message.error(err?.response?.data?.message || err.message);
        } finally {
            setIsLoading(false);
            onClose();
        }

    };

    return (
        <Main width="50%" height="50%" title="add user for admission">
            <div className={classNames.addUserForm}>
                <form ref={ref} className={classNames.userForm} onSubmit={handleSubmit}>
                    <Input2
                        type="text"
                        returnKey="fullName"
                        fieldName="Full Name*"
                        state={formValues}
                        setState={(v) => setFormValues(v)}
                        required
                        className="w-full"
                    />
                    <Input2
                        type="text"
                        returnKey="phoneNumber"
                        fieldName="Phone Number*"
                        state={formValues}
                        setState={(v) => setFormValues(v)}
                        max={10}
                        required
                        className="w-full"
                    />
                    <Input2
                        type="drop"
                        fieldName="Select Class*"
                        className="w-full"
                        state={formValues}
                        setState={(v) => setFormValues(v)}
                        options={classQuery?.data?.list || []}
                        returnKey="classId"
                        optionDisplay="className"
                        optionKey="_id"
                        didntShowKey
                        required
                    />
                    <div className="flex justify-end w-full mt-4">
                        <Button type="submit">
                            Submit
                            <ArrowRightOutlined style={{ fontSize: 20, marginLeft: 5 }} />
                        </Button>
                        <Button type="close"
                            onClick={onClose}
                        >
                            close
                        </Button>

                    </div>

                </form>

                {/* {isLoading && (
        <div className={classNames.loading}>
          <LoadingAnimation />
        </div>
      )} */}
            </div>
        </Main>
    );
}

export default AddNewUsertoAdmission;
